import Link from 'next/link'
import React, { memo } from 'react'
import CartHeader from 'src/components/global/Cart/CartHeader'
import CartHeaderTitle from 'src/components/global/Cart/CartHeaderTitle'
import { ISolutionArticleFragment, Maybe } from 'src/graphql/generated/hooks'

import { ArticleItem } from '../ArticleItem/ArticleItem'

export interface ArticleCartProps {
  articles: Maybe<ISolutionArticleFragment>[]
  className?: string
}

export const ArticleCart: React.FC<ArticleCartProps> = memo(({ articles }) => {
  return (
    <div className="w-full border-[1px] border-mist rounded-[5px] mt-[2rem]">
      <CartHeader>
        <CartHeaderTitle>Articles</CartHeaderTitle>
      </CartHeader>
      {articles
        .slice() // Make a copy of the articles before sorting to avoid mutating the original one
        .sort((articleA, articleB) => {
          const dateA = articleA?.date ? new Date(articleA.date).getTime() : 0
          const dateB = articleB?.date ? new Date(articleB.date).getTime() : 0
          return dateB - dateA
        })
        .map((article, index) =>
          article?.link ? (
            <Link href={article.link ?? '#'} key={index} target="_blank">
              <ArticleItem article={article}></ArticleItem>
            </Link>
          ) : null,
        )}
    </div>
  )
})
